import React, { useState, useEffect } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Basic from './Basic';
import Agree from './Agree';
import Project from './Project';
import Boat from './Boat';
import Pier from './Pier';
import Original_Equity from './Original_Equity';
import Last_Equity from './Last_Equity';
import NotifyDialog from './NotifyDialog';
import Actions_Wind_V2 from '~/Actions_Wind_V2';
import { logError } from '~/common/utils';

const styles = (theme) => ({
  root: {
  }
});

const App = (props) => {
  const [openNotify, setOpenNotify] = useState(false);
  const [notificationCounts, setNotificationCounts] = useState({
    admin_program_size: 0,
    work_progress_size: 0
  });

  useEffect(() => {
    const fetchNotificationCounts = async () => {
      try {
        const [adminPrograms, workProgress] = await Promise.all([
          Actions_Wind_V2.getAllUnapprovalAdminPrograms(),
          Actions_Wind_V2.getAllUnapprovalWorkProgress()
        ]);

        setNotificationCounts({
          admin_program_size: adminPrograms?.length || 0,
          work_progress_size: workProgress?.length || 0
        });
        setOpenNotify(true);
      } catch (error) {
        logError(error, 'fetchNotificationCounts');
      }
    };

    fetchNotificationCounts();
  }, []);

  const handleCloseNotify = () => {
    setOpenNotify(false);
  };

  return (
    <div style={{
      position: 'absolute',
      left: 13,
      right: 0,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'auto',
    }}
    >
      <NotifyDialog 
        open={openNotify} 
        onClose={handleCloseNotify}
        notificationCounts={notificationCounts}
      />
      <Basic />
      <Agree />
      <Project />
      <Boat />
      <Pier />
      <Original_Equity />
      <Last_Equity />
    </div>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({});

export default compose(connect(mapStateToProps, mapDispatchToProps), withStyles(styles))(App);
